<template>
  <div style="display: flex; flex-direction: column;">
    <div :style="'position: relative; top: '+($store.getters.getScreenWidth>500 ? '70vh' : '50vh')+'; display: flex; flex-direction: row; flex-wrap: wrap; justify-content: center; align-items: center;'">

        <!--<div 
            onClick="window.location='https://us.shaklee.com/site/soul/storefront'" 
            :style="'cursor: pointer; margin: 10px; padding: '+($store.getters.getScreenWidth>500 ? '30px' : '10px')+'; background-image: linear-gradient(black, #cccccc); border-radius: 25px;'">
            <a href="https://us.shaklee.com/site/soul/storefront" 
              :style="'font-size: '+($store.getters.getScreenWidth>500 ? '24px' : '14px')+'; font-family: \'Roboto\', sans-serif; font-weight: bold; color: white; text-transform: uppercase;'">
                WIN a 2024 KIA Soul
            </a>
        </div>
        
        <div 
          @click="moveToURL"
          onClick="window.location=''" 
          :style="'cursor: pointer; margin: 10px; padding: '+($store.getters.getScreenWidth>500 ? '30px' : '10px')+'; background-image: linear-gradient(black, #cccccc); border-radius: 25px;'">
          <a 
            @click="moveToURL"
            :style="'font-size: '+($store.getters.getScreenWidth>500 ? '24px' : '14px')+'; font-family: \'Roboto\', sans-serif; font-weight: bold; color: white; text-transform: uppercase;'">
            REGISTER
          </a> 
        </div>-->

        <div 
          onClick="window.location='https://us.shaklee.com/site/soul/storefront'" 
          :style="'display: flex; flex-direction: column; justify-content: center; align-items: center; cursor: pointer; margin: 10px; padding: '+($store.getters.getScreenWidth>500 ? '30px' : '10px')+'; background-image: linear-gradient(black, #cccccc); border-radius: 25px;'">
          <img src="https://raizzoncdn.b-cdn.net/coastalkia5k/meology_white.png" width="75" />
          <a href="https://us.shaklee.com/site/soul/storefront" 
            :style="'font-size: '+($store.getters.getScreenWidth>500 ? '14px' : '14px')+'; font-family: \'Roboto\', sans-serif; font-weight: bold; color: white; text-transform: uppercase;'">
            WIN a 2024 KIA Soul
          </a>
        </div>

    </div>
    <div :style="'width: 100%; text-align: center; position: relative; top: '+($store.getters.getScreenWidth>500 ? '70vh' : '53vh')+''">
      <a href="https://www.constantcontact.com/partner-offer?pn=greenisbig">
        <img src="https://raizzoncdn.b-cdn.net/coastalkia5k/roi_stat_banner_728x90_hmpg.gif" :style="$store.getters.getScreenWidth>500 ? 'width: 250px;' : 'max-width: 250px;'" alt="">
      </a>      
    </div>

  </div>
</template>

<script>

export default {
  components: {
  },
  computed: {
      getRefIndex() {
        return this.$store.getters.getRefCompany
      }
  },
  methods: {
    moveToURL() {
      window.location= 'https://runsignup.com/Race/Events/NC/Hampstead/CoastalKIA5K'+(this.getRefIndex !== null ? '?'+this.getRefIndex.ref_link : '')
    }
  },
  created() {
    
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Home.vue